export class DepartmentModel {
    public Id: number = 0;
    public AccountId: number = 0;
    public Name: string = "";
    public Description: string = "";
    public DepartmentHead: string = "";
    public ContactNumber: string = "";
    public CreatedDate: string = "";
    public LastUpdatedDate: string = "";
}



// WEBPACK FOOTER //
// ./src/app/models/DepartmentModel.ts